<template>
  <div id="to-info-component">
    <v-container v-if="$route.name !== 'instant-list'" style="padding:0px;">
    <div style="box-shadow: 0px 0px 4px 0px #c9c9c9; width:100%; padding: 15px 0px 15px 0px;  ">
    <v-layout row wrap>
    <v-flex x12 v-if="$route.name !== 'instant-list'" style="display:flex; align-items:center;">
          <v-btn small icon dark :to="back()">
            <v-icon color="#10aa85">arrow_back</v-icon>
          </v-btn>
          <h2 class="fw400" v-if="$route.name !== 'mata-pelajaran'" style="color:#10AA85">Detail Tryout</h2>
          <h2 class="fw400" v-if="$route.name == 'mata-pelajaran'" style="color:#10AA85">Subtest </h2>
        </v-flex>
        
    </v-layout>
    </div>

      <v-layout row wrap>
        <div class="martop04em" style="padding-left:20px; padding-top:15px;" v-if="$route.name !== 'mata-pelajaran'">
              <b style="color:#4C63C9;" v-if="data['type'] === 'UJIAN_AKHIR_SEKOLAH'">UAS</b>
              <b style="color:#4C63C9;" v-else-if="data['type'] === 'SBMPTN'">SNBT</b>
              <b style="color:#4C63C9;" v-else-if="data['type'] === 'UJIAN_AKHIR_NASIONAL' || data['type'] === 'UJIAN_NASIONAL'">UN</b>
              <b style="color:#4C63C9;" small v-else-if="data['type'] === 'PENILAIAN_AKHIR_SEMESTER'">PAS</b>
              <b style="color:#4C63C9;" v-else-if="data['type'] === 'PENILAIAN_TENGAH_SEMESTER'">PTS</b>
              <b style="color:#4C63C9;" v-else-if="data['type'] === 'UJIAN_SEKOLAH'">US</b>
              <b style="color:#4C63C9;" v-else-if="data['type'] === 'UJIAN_MANDIRI'">Mandiri</b>
            </div>
        <v-flex style="padding-left:20px;" xs12 v-if="$route.name === 'tryout-list' || $route.name === 'result' || $route.name === 'tryout-list-serial' ">
          <h2 style="color:#494949;">{{ data.name }}</h2>
            <v-layout row wrap>
              <v-flex xs12>
                <p style="margin-bottom:0px; font-weight:bold; color:#494949;">Periode Tryout:</p>
                <span id="ic-actions-sbs" style="color:#9C9C9C;">
                <img
                src="@/assets/icon/result/ic_tanggal.svg"
                alt="image-alt"
                style="width: 20px; margin-right: 4px;"
              />
              &nbsp; {{ data.opened_at | moment("DD MMM YYYY") }} - {{ data.closed_at | moment("DD MMM YYYY") }}</span>
              </v-flex>
            </v-layout>
        </v-flex>
        <v-flex style="margin:25px !important;" xs12 v-else-if="$route.name === 'mata-pelajaran' || $route.name === 'mata-pelajaran-s' || $route.name === 'mata-pelajaran-instant'">
         <span style=" font-size:14px;">
                <b style="color:#10AA85" v-if="data.category === 'TPS'">TPS</b>
                <b style="color:#AD7ACF" v-if="data.category === 'SAINTEK'">SAINTEK</b>
                <b style="color:#EB5757" v-if="data.category === 'SOSHUM'">SOSHUM</b>
                <b style="color:#00ADE2;" v-if="data.category === 'LITERASI'">LITERASI</b>
                <b style="color:#00ADE2;" v-if="data.category === 'OTHER'">OTHER</b>
              </span>
         <h2 style="color:#494949;">{{ data.name }}</h2>
          <v-layout row wrap class="" style="color:#9C9C9C; font-size:12px;">
            <v-flex xs12 v-if="$route.name !== 'mata-pelajaran-instant'">
              <b style="font-weight:bold; color:#494949; font-size:12px;">Periode Pengerjaan:</b>
            </v-flex>
            <v-flex xs12 v-if="$route.name !== 'mata-pelajaran-instant'" style="display:flex; align-items:center; padding-bottom: 0px;">
              <img
                src="@/assets/icon/result/ic_tanggal.svg"
                alt="image-alt"
                style="width: 20px; margin-right: 4px;"
              /> Mulai {{ data.start_date + ' ' + data.start_time | moment("DD MMMM YYYY HH:mm")}}
            </v-flex>
            <v-flex xs12 v-if="$route.name !== 'mata-pelajaran-instant'" style="display:flex; align-items:center;">
              <img
                src="@/assets/icon/result/ic_tanggal.svg"
                alt="image-alt"
                style="width: 20px; margin-right: 4px;"
              /> Selesai {{ data.end_date + ' ' + data.end_time | moment("DD MMMM YYYY HH:mm")}}
            </v-flex>
            <v-flex xs3 style="display:flex; align-items:center; padding-bottom: 5px;">
              <img
                src="@/assets/icon/ic_durasi.svg"
                alt="image-alt"
                style="width: 20px; margin-right: 4px;"
              />
               {{data.duration + ' menit'}}
            </v-flex>
            <v-flex xs8 style="display:flex; align-items:center; padding-bottom: 5px;">
             <img
                src="@/assets/icon/result/ic_soal.svg"
                alt="image-alt"
                style="width: 20px; margin-right: 4px;"
              />
              {{ data | countingSubtes}} Soal
            </v-flex>
          </v-layout>
        </v-flex>
        

      </v-layout>
    </v-container>

<!-- UJIAN INSTANT HEADER ================================================================================================================== -->
    <v-container :class="'info-detail-sbs'" v-if="$route.name === 'instant-list'">
      <v-layout row wrap>
        <v-flex x12>
          <v-btn small icon dark :to="back()">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs10 offset-xs2 >
          <h2 class="white--text">{{ data.name }}</h2>
            <v-layout row wrap>
              <v-flex xs12>
                <span id="ic-actions-sbs"><v-icon dark size="15">assignment</v-icon>&nbsp; {{ data.level }}</span>
              </v-flex>
              <v-flex xs12>
                <!-- <span id="ic-actions-sbs"><v-icon dark size="15">chrome_reader_mode</v-icon>&nbsp; {{ data | countingSoal}} Soal</span> -->
              </v-flex>
              <v-flex xs12></v-flex>
            </v-layout>

            <div class="martop04em">
              <v-btn light depressed round small v-if="data['type'] === 'UJIAN_AKHIR_SEKOLAH'">UAS</v-btn>
              <v-btn light depressed round small v-else-if="data['type'] === 'SBMPTN'">SNBT</v-btn>
              <v-btn light depressed round small v-else-if="data['type'] === 'UJIAN_AKHIR_NASIONAL' || data['type'] === 'UJIAN_NASIONAL'">UN</v-btn>
              <v-btn light depressed round small v-else-if="data['type'] === 'PENILAIAN_AKHIR_SEMESTER'">PAS</v-btn>
              <v-btn light depressed round small v-else-if="data['type'] === 'PENILAIAN_TENGAH_SEMESTER'">PTS</v-btn>
              <v-btn light depressed round small v-else-if="data['type'] === 'UJIAN_SEKOLAH'">US</v-btn>
              <!-- <v-btn light depressed round small v-if="data.tryouts">{{ data.tryouts[0].display_name}}</v-btn> -->
            </div>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VRecognition from './SpeechRecognition'
/* eslint-disable */
export default {
  name: 'to-info-component',
  components: {
    'voice-recognition': VRecognition
  },
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  data: function () {
    return {
      text: '',
      sentences: null
    }
  },
  filters: {
    countingSoal(value) {
      var total = 0
      if(value.tryouts && value.tryouts.length > 0){
        for(var i = 0; i < value.tryouts.length; i++){
          var subtes = value.tryouts[i].subtests
          if(subtes && subtes.length > 0){
            for (var a = 0; a < subtes.length; a++) {
              total += subtes[a].item_count
            }
          } else {
            return 0
          }
        }
        return total
      } else {
        return 0
      }
    },
    countingSubtes (value) {
      var total = 0
      var subtes = value.subtests
        if(subtes && subtes.length > 0){
          for (var a = 0; a < subtes.length; a++) {
            total += subtes[a].item_count
          }
          return total 
        } else {
          return 0
        }
    },
    timeConvert (n) {
      var num = n;
      var hours = (num / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      if (num < 60) {
        return num + ' menit';
      }else if(rminutes > 0) {
        return rhours + " jam " + rminutes + " menit";
      } else if (rminutes == 0 && rhours == 1) {
        return num + " menit";
      } else {
        return rhours + " jam";
      } 
    }
  },
  created() {
    // console.log(this.data)
  },
  methods: {
    speechEnd ({sentences, text}) {
      this.sentences = sentences
    },
    back(){
      if(this.$route.name === 'tryout-group' || this.$route.name === 'serial'){
        return '/'
      }else if(this.$route.name === 'serial-list'){
        return '/serial'
      }else if(this.$route.name === 'instant-list'){
        return '/'
      }else if(this.$route.name === 'mata-pelajaran-instant'){
        return '/instant/test-list'
      }else if (this.$route.name === 'tryout-detail'){
        return '/tryout/' + this.$route.params.id
      }else if (this.$route.name === 'mata-pelajaran'){
        return '/tryout/' + this.$route.params.id
      }else if (this.$route.name === 'tryout-list-serial'){
        return '/serial/' + this.$route.params.id + '/list'
      }else if (this.$route.name === 'tryout-serial-detail'){
        return '/tryout/' + this.$route.params.id + '/serial/' + this.$route.params.cid
      }else if (this.$route.query.trend){
        return '/'
      }else{
        return '/tryout-group'
      }
    }
  },
  watch: {
    text (to, from) {
      this.$emit('search', to.trim())
    }
  }
}
</script>
